import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const imgSrc = (u, w) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}${w ? `?w=${w}` : ""}` : u || "/img/logo-sm.webp");
export const imgFallback = (e) => {
  if (!e.currentTarget.dataset.fb) {
    e.currentTarget.dataset.fb = "1";
    e.currentTarget.src = "/img/logo-sm.webp";
    e.currentTarget.classList.add("!object-contain", "p-6", "opacity-70");
  }
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Lütfen form alanlarını kontrol edin";
  return "Bir hata oluştu, lütfen tekrar deneyin";
};

export function useApi() {
  const { getToken, isSignedIn } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = localStorage.getItem("cvz_token") || (isSignedIn ? await getToken() : null);
      const headers = { ...(config.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) };
      const res = await api.request({ method, url, data, ...config, headers });
      return res.data;
    },
    [getToken, isSignedIn],
  );
}

export async function openBlob(call, url, filename) {
  const blob = await call("get", url, null, { responseType: "blob" });
  const href = URL.createObjectURL(blob);
  if (filename) {
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    a.click();
  } else {
    window.open(href, "_blank");
  }
  setTimeout(() => URL.revokeObjectURL(href), 60000);
}

export async function openInvoice(call, inv, simPath, linkPath) {
  if (inv.status === "simulasyon") return openBlob(call, simPath);
  if (inv.pdf_url) return window.open(inv.pdf_url, "_blank");
  const win = window.open("", "_blank");
  try {
    const r = await call("get", linkPath);
    win.location.href = r.url;
  } catch (e) {
    win.close();
    throw e;
  }
}
